import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SelectClass = ({ classData, setClassData, courses, loadingCourses }) => {
  const [errors, setErrors] = useState([]);
  const { state } = useContext(AuthContext);

  const [batches, setBatches] = useState([]);
  const navigate = useNavigate();

  const handleCourseChange = (event) => {
    const courseId = event.target.value;
    const selectedCourse = courses.find(
      (course) => course.courseId === courseId
    );
    setBatches(selectedCourse?.batches || []);
    setClassData({ ...classData, courseId, batchId: '' });
  };

  const handleBatchChange = (event) => {
    const batchId = event.target.value;
    setClassData({ ...classData, batchId });
  };

  //   useEffect(() => {
  //     const newErrors = [];
  //     if (!classData?.courseId || !classData?.batchId.trim()) {
  //       newErrors.push('Please fill in all fields.');
  //     }
  //     setErrors(newErrors);
  //     setDisable(newErrors.length > 0);
  //   }, [classData, setDisable]);

  useEffect(() => {
    if (classData.courseId) {
      const selectedCourse = courses.find(
        (course) => course.courseId === classData.courseId
      );
      setBatches(selectedCourse?.batches || []);
    }
  }, [classData.courseId, courses]);

  return (
    <div className="w-full rounded-lg ">
      {/* Header */}
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Class Information
        </h4>
      </div>

      {/* Course Select */}
      <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>
          <select
            onChange={handleCourseChange}
            value={classData?.courseId}
            name="course"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>
            {loadingCourses ? (
              <option>Loading courses...</option>
            ) : (
              <>
                {' '}
                {courses.map((course, i) => (
                  <option key={course.courseId} value={course.courseId}>
                    {i + 1}. {course.courseName}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>

        {/* Batch Select */}
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch
          </label>
          <select
            onChange={handleBatchChange}
            value={classData?.batchId}
            name="batch"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Batch</option>
            {batches.length > 0 ? (
              batches.map((batch) => {
                // Extract unique times from daySchedules
                const times = batch.daySchedules
                  ?.map((ds) => ds.startTime)
                  .filter(Boolean);
                const uniqueTimes = [...new Set(times)]; // remove duplicates
                const timeDisplay =
                  uniqueTimes.length > 0
                    ? ` at ${uniqueTimes.join(' / ')}`
                    : '';

                return (
                  <option key={batch._id} value={batch._id}>
                    B {batch.batchNumber} - From{' '}
                    {new Date(batch.startDate).toLocaleDateString()} {''}
                    to {new Date(batch.endDate).toLocaleDateString()}
                    {timeDisplay}
                  </option>
                );
              })
            ) : (
              <option className="cursor-pointer" value="">
                No batches available
              </option>
            )}
          </select>
        </div>
      </div>
      {/* Display errors */}
      {errors.length > 0 && (
        <div className="text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectClass;
